import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';

export default class FilterButtons extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeFilter: 'all',
    };
  }

  handleFilterClick(type) {
    const { changeFilter } = this.props;
    this.setState({ activeFilter: type });
    changeFilter(type);
  }

  render() {
    const { activeFilter } = this.state;
    return (
      <div className="categories-filter-wrapper my-4">
        <Button
          size="sm"
          className={`filter-button orange ${activeFilter === 'all' ? 'active' : ''}`}
          type="button"
          onClick={ () => this.handleFilterClick('all') }
          data-testid="filter-by-all-btn"
        >
          ✨ Todos
        </Button>
        <Button
          size="sm"
          className={`filter-button orange ${activeFilter === 'comida' ? 'active' : ''}`}
          type="button"
          onClick={ () => this.handleFilterClick('comida') }
          data-testid="filter-by-food-btn"
        >
          🥘 Comidas
        </Button>
        <Button
          size="sm"
          className={`filter-button orange ${activeFilter === 'bebida' ? 'active' : ''}`}
          type="button"
          onClick={ () => this.handleFilterClick('bebida') }
          data-testid="filter-by-drink-btn"
        >
          🍸 Bebidas
        </Button>
      </div>
    );
  }
}

FilterButtons.propTypes = {
  changeFilter: PropTypes.func.isRequired,
};
